import { trackMarketingEvent } from "./marketingEvents";

export type ComparatorEventName =
  | "forfeo_comparator_view"
  | "forfeo_comparator_home_category_click"
  | "forfeo_comparator_category_select"
  | "forfeo_comparator_widget_ready"
  | "forfeo_comparator_partner_launch"
  | "forfeo_comparator_local_suggestion_click"
  | "forfeo_comparator_cross_sell_click"
  | "forfeo_comparator_alert_click"
  | "forfeo_comparator_plan_update"
  | "forfeo_comparator_plan_saved"
  | "forfeo_comparator_plan_continue";

type EventDetails = Record<string, string | number | boolean | undefined>;

const SESSION_KEY = "forfeo_compare_session_id";
const LAST_CATEGORY_KEY = "forfeo_compare_last_category";
const FIRST_TOUCH_KEY = "forfeo_compare_first_touch";

function getOrCreateSessionId(): string {
  try {
    const existing = window.sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id = typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return "session-unavailable";
  }
}

export function rememberComparatorCategory(category: string) {
  try {
    window.localStorage.setItem(LAST_CATEGORY_KEY, category);
    if (!window.localStorage.getItem(FIRST_TOUCH_KEY)) {
      window.localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify({ category, at: new Date().toISOString() }));
    }
  } catch {
    // Le stockage local ne doit jamais bloquer la navigation.
  }
}

export function getLastComparatorCategory(): string | null {
  try {
    return window.localStorage.getItem(LAST_CATEGORY_KEY);
  } catch {
    return null;
  }
}

function marketingType(eventName: ComparatorEventName) {
  if (eventName.includes("view") || eventName.includes("widget_ready")) return "page_view";
  if (eventName.includes("partner_launch")) return "outbound_click";
  if (eventName.includes("alert")) return "conversion";
  if (eventName.includes("plan_saved") || eventName.includes("plan_continue")) return "conversion";
  return "internal_click";
}

export function trackComparatorEvent(eventName: ComparatorEventName, details: EventDetails = {}) {
  try {
    const payload = {
      eventName,
      comparator_session_id: getOrCreateSessionId(),
      page_path: window.location.pathname,
      page_query: window.location.search,
      ...details,
    };

    window.dispatchEvent(new CustomEvent("forfeo:comparator", { detail: payload }));

    const dataLayerWindow = window as Window & { dataLayer?: Array<Record<string, unknown>> };
    dataLayerWindow.dataLayer?.push({ event: eventName, ...payload });

    void trackMarketingEvent({
      event_type: marketingType(eventName),
      event_name: eventName,
      label: String(details.action || details.suggestion || details.category || eventName),
      target_url: typeof details.destination === "string" ? details.destination : "",
      source: "forfy_compare",
      metadata: payload,
    });
  } catch {
    // Le suivi ne doit jamais bloquer le comparateur.
  }
}
